import { Alert } from '@calendly/alert';
import { FeatureCheckProvider } from '@calendly/feature-check-react';
import { useBodyStyles } from '@calendly/ui/body-styles';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { Router, Route } from 'react-router-dom';
import { useTrackPageLoad, SegmentScript } from 'components/segment';
import { TaxInformationModal } from 'features/billing';
import { PaymentPage } from 'features/payment_link';
import { paymentPageDeprecatedPaths, PaymentPageDeprecationMessage } from 'features/payment_page_deprecation_message';
import { decisionEventService } from 'services/analytics/decision_event_service';
const Routes = () => {
  useBodyStyles();
  useTrackPageLoad();
  const paymentPagePaths = ['/payment/:deal_uuid', '/:lang/payment/:deal_uuid'];
  return <>
      <TaxInformationModal />
      <SegmentScript />
      <Alert />
      <Route exact path={paymentPagePaths} component={PaymentPage} />
      <Route exact path={paymentPageDeprecatedPaths} component={PaymentPageDeprecationMessage} />
    </>;
};
export default ({
  store,
  history,
  enabledFeatures,
  layers,
  isAuthenticated
}) => {
  const bodyStyles = "b1w91jda";
  useBodyStyles({
    bodyStyles
  });
  return <StrictMode>
      <FeatureCheckProvider enabledFeatures={enabledFeatures} layers={layers} isAuthenticated={isAuthenticated} trackDecisionEvent={decisionEventService.track}>
        <Provider store={store}>
          <Router history={history}>
            <Routes />
          </Router>
        </Provider>
      </FeatureCheckProvider>
    </StrictMode>;
};

require("./payment.wyw-in-js.css!=!../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./payment.js");